export default __webpack_public_path__ + "static/media/nodejsback.1757333a.svg";